<template>
  <div class="loading-box">
    <b-loading :is-full-page="fullPage" :active="true"></b-loading>
  </div>
</template>

<script>
export default {
  props: {
    fullPage: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [String, Number],
      default: '5rem',
    },
  },
  computed: {
    chartHeight() {
      return 'height: ' + this.height
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-box {
  min-height: 5rem;
  width: auto;
  position: relative;
}
</style>
